<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card border">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">Data Voucher</h4>

                                    <div class="page-title-right">
                                        <router-link class="btn btn-primary rounded" :to="{name : 'voucher_add'}"><i class="fa fa-plus"></i> Tambah Data</router-link>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-4 mt-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlSelect1">Kategori</label>
                                            <select class="form-select" id="exampleFormControlSelect1" v-model="category" v-on:change="getData">
                                                <option value="">Lihat Semua</option>
                                                <option value="tryout">Tryout</option>
                                                <option value="cpns">Paket CPNS</option>
                                                <option value="kedinasan">Paket Kedinasan</option>
                                                <option value="pppk">Paket PPPK</option>
                                                <option value="olimpiade">Paket Olimpiade</option>
                                                <option value="esai">Paket Esai</option>
                                                <option value="lkti">Paket LKTI</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-8 mt-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlSelect1">Kata kunci</label>
                                            <div class="input-group">
                                                <input type="text" autocomplete="off" class="form-control" aria-describedby="emailHelp" placeholder="Cari data berdasarkan kata kunci..." v-model="keywords" v-on:keyup.enter="getData">
                                                <div class="input-group-append">
                                                    <button v-on:click="getData" class="btn waves-effect waves-light btn-primary btn-icon btn-msg-send" type="button"><i
                                                            class="fa fa-search"></i> Cari </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr/>
                                <div v-if="dataFetch">
                                    <p>Sedang mengambil data...</p>
                                </div>

                                <div v-if="!dataFetch">
                                    <div v-if="dataList.length > 0" class="table-responsive mt-3">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th style="width:5%" class="text-center">No</th>
                                                    <th style="width:25%">Kode Voucher</th>
                                                    <th style="width:8%" class="text-center">Kategori</th>
                                                    <th style="width:8%" class="text-center">Tipe</th>
                                                    <th style="width:15%" class="text-center">Nominal</th>
                                                    <th style="width:15%" class="text-center">Berlaku</th>
                                                    <th style="width:20%">Berlaku Hingga</th>
                                                    <th style="width:5%">Kuota</th>
                                                    <th class="text-center" style="width:19%">Aksi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in dataList" :key="index">
                                                    <td class="text-center">
                                                        {{ (index + 1) + (pagination.currentPage - 1) * pagination.limit }}
                                                    </td>
                                                    <td>{{item.code}}</td>
                                                    <td class="text-center">
                                                        <span v-if="item.category == 'tryout'" class="badge bg-warning">Tryout</span>
                                                        <span v-if="item.category == 'cpns'" class="badge bg-info">Paket CPNS</span>
                                                        <span v-if="item.category == 'kedinasan'" class="badge bg-primary">Paket Kedinasan</span>
                                                        <span v-if="item.category == 'pppk'" class="badge bg-light">Paket PPPK</span>
                                                        <span v-if="item.category == 'olimpiade'" class="badge bg-light">Paket Olimpiade</span>
                                                        <span v-if="item.category == 'esai'" class="badge bg-light">Paket Esai</span>
                                                        <span v-if="item.category == 'lkti'" class="badge bg-light">Paket LKTI</span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span v-if="item.type == 'nominal'" class="badge bg-info">Nominal</span>
                                                        <span v-if="item.type == 'percentage'" class="badge bg-primary">Persentasi</span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span v-if="item.type == 'nominal'" >{{item.nominal}}</span>
                                                        <span v-if="item.type == 'percentage'" >{{item.nominal}}%</span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span v-if="item.apply == 'once'" >Sekali Pakai</span>
                                                        <span v-if="item.apply == 'repeated'" >Berulang</span>
                                                    </td>
                                                    <td>
                                                        {{item.text_expired}}
                                                    </td>
                                                    <td class="text-center">
                                                        {{item.quota}}
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="button-items">
                                                            <!-- <router-link :to="{name : 'voucher_edit', params: {id:item.id}}" type="button" class="btn btn-primary btn-sm rounded"><i class="fas fa-edit"></i> Ubah</router-link> -->
                                                            <button v-on:click="deleteData(item.id)" type="button" class="btn btn-danger btn-sm rounded"><i class="fas fa-trash"></i> Hapus</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <nav v-if="dataList.length > 0" aria-label="navigation" class="mt-3">
                                        <v-pagination v-model="pagination.currentPage" :page-count="pagination.totalPages" :classes="pagination.bootstrapPaginationClasses" :labels="pagination.paginationAnchorTexts" v-on:change="getData()"></v-pagination>
                                    </nav>

                                    <div v-if="emptyState">
                                        <empty-state></empty-state>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vPagination from 'vue-plain-pagination'

    export default {
        name: 'voucher',
        metaInfo: {
            title: 'Data Voucher',
            titleTemplate: '%s - Gubuk Sains Prima'
        },
        components: {
            vPagination
        },
        data() {
            return {
                emptyState  : false,
                dataFetch   : false,
                dataList    : [],
                keywords    : "",
                category    : "",
                pagination: {
                    currentPage : 1,
                    totalPages  : 0,
                    limit       : 10,
                    bootstrapPaginationClasses: {
                        ul: 'pagination justify-content-end',
                        li: 'page-item',
                        liActive: 'active',
                        liDisable: 'disabled',
                        button: 'page-link'
                    },
                    paginationAnchorTexts: {
                        first: 'First',
                        prev: 'Previous',
                        next: 'Next',
                        last: 'Last'
                    }
                }
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData: function() {
                let uri         = process.env.VUE_APP_APIHOST+'admin/voucher/list';

                this.dataFetch  = true;                
                this.$http.get(uri,{
                    params : {
                        category : this.category,
                        keywords : this.keywords,
                        page     : this.pagination.currentPage,
                        limit    : this.pagination.limit
                    }
                }).then(res => {
                    this.emptyState             = false;
                    this.dataFetch              = false;                
                    this.dataList               = res.data.data;
                    this.pagination.totalPages  = res.data.total_page;

                    if(this.dataList.length < 1) {
                        this.emptyState = true;
                    }
                });
            },
            deleteData: function (id) {
                this.$swal({
                    icon: 'info',
                    title: 'Hapus Data',
                    text: 'Apakah kamu yakin ingin menghapus data ini?',
                    confirmButtonText: 'Hapus',
                    showCancelButton: true,
                    cancelButtonText: 'Batal',
                }).then((result) => {
                if (result.value) {
                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/voucher/delete', {
                        id: id
                    })
                    .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.getData();
                                }
                            });
                        } else {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: response.data.message,
                        });
                        }
                    })
                }
                });
            }
        }
    }
</script>